<template>
  <div class="group-cpc">
    <span
    class="group-cpc__text"
    :class="isAdmin && 'pointer'"
    @click="openEditor">
      {{ cpc ? cpc : '—' }}
    </span>

    <transition name="fade">
      <div
      v-if="showEditor"
      v-click-outside="onClickOutside"
      class="group-cpc__editor">
        <div class="group-cpc__editor-element">
          <span class="group-cpc__text_light">
            {{ $t('Edit a CPC') }}
          </span>
          <input
          v-model="cpcValue"
          type="text"
          :placeholder="$t('Specify the CPC')"
          class="group-cpc__input">
        </div>
        <TJButton
        :text="$t('save')"
        type="text"
        @handler="saveChanges" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GroupCpc',
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: null,
    },
    cpc: {
      type: [String, Number],
      default: null,
    },
  },
  data: () => ({
    showEditor: false,
    cpcValue: null,
  }),
  methods: {
    openEditor() {
      if (!this.isAdmin) {
        return;
      }
      this.cpcValue = this.cpc;
      this.showEditor = true;
    },
    closeEditor() {
      this.showEditor = false;
      this.cpcValue = null;
    },
    onClickOutside() {
      this.closeEditor();
    },
    saveChanges() {
      const newData = {
        cpc: this.cpcValue === '' ? null : this.cpcValue,
      };

      this.showEditor = false;

      this.$store.dispatch('groups/groupUpdate', { id: this.group.id, social: this.group.social, newData })
        .then(() => {
          this.group.cpc = this.cpcValue === '' ? null : this.cpcValue;
          this.$store.dispatch('app/setSnackBar', { text: this.$t('Data updated'), error: false });
        })
        .catch(() => {
          this.$store.dispatch('app/setSnackBar',
            {
              text: this.$t('An error occurred while updating the data'),
              error: true,
            });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.group-cpc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 180px;
  min-height: 50px;
  position: relative;
}

.group-cpc__text {
  font-size: 12px;
  color: $primary-gray;
  text-align: center;
  word-break: break-all;
  &_light {
    font-size: 12px;
    color: $primary-lightgray;
  }
}

.group-cpc__editor {
  position: absolute;
  top: 0px;
  left: 30px;
  min-width: 200px;
  border-radius: 12px;
  padding: 20px 20px 0px;
  box-shadow: 0px 0px 10px 1px rgb(34 60 80 / 10%);
  background: $primary-white;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include between-elements {
    margin-bottom: 10px;
  }
}

.group-cpc__editor-element {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include between-elements {
    margin-bottom: 5px;
  }
}

.group-cpc__input {
  padding: 5px 10px;
  border: 1px solid $primary-lightgray;
  border-radius: 8px;
  font-size: 12px;
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-size: 12px;
    color: $primary-lightgray;
  }
}

</style>
